<script lang="ts">

    const { title, url, btnTitle } = $props<{ title?: string, url?: string, btnTitle?: string }>();

    const urls = [
        {
            url: 'https://www.facebook.com/sapcx',
            icon: '/img/facebook.svg',
            alt: 'facebook logo'
        },
        {
            url: 'https://www.linkedin.com/company/sapcx',
            icon: '/img/linkedin.svg',
            alt: 'linkedin logo'
        },
        {
            url: 'https://www.youtube.com/c/sapcx',
            icon: '/img/youtube.svg',
            alt: 'youtube logo'
        },
        {
            url: 'https://www.instagram.com/sapcx/',
            icon: '/img/instagram.svg',
            alt: 'instagram logo'
        }
    ];
</script>

<footer class="flex relative flex-col bg-fixed justify-end items-center bg-bottom px-18 w-full min-h-70 bg bg-cover bg-no-repeat z-10 mt-36 ">
    {#if title}
    <div class="absolute -top-15 left-15 right-15 m-auto py-7 px-4 my-shadow bg-indigo-300 flex flex-row justify-around items-center flex-wrap">
        <div class="text-2xl text-black grow-0 max-md:mb-4 max-md:text-lg">{@html title}</div>
            <button onclick={() => location.href = url } class="bg-indigo-500 flex-gr h-14 px-6 rounded-lg cursor-pointer text-xl shadow-sm shadow-black active:shadow-2xs hover:bg-indigo-600">
            {btnTitle} 
        </button>
    </div>
    {/if}
    
    <img src="/img/sap-logo.svg" class="h-14 object-contain" alt="logo" />
    <div class="flex w-80 justify-between my-6">
        {#each urls as { url, icon, alt }}
            <a href={url} class="bg-indigo-700 p-2 rounded-full shadow-md shadow-indigo-200 hover:shadow-lg hover:bg-indigo-600">
                <img src={icon} alt={alt} class="h-8 w-8">
            </a>
        {/each}
    </div>
</footer>

<style>
    .bg {
        background-image: url('/img/bg2.png');
    }

    .my-shadow {
        box-shadow: -22px -22px 0px 0 rgb(163 179 255 / 20%);
    }
</style>